/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const EmptyIcon: React.FC = (): JSX.Element => (
  <svg width="101" height="77" viewBox="0 0 101 77" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="2"
      y1="-2"
      x2="28.3019"
      y2="-2"
      transform="matrix(0.695782 0.718253 -0.797675 0.603088 46.4866 54.5945)"
      stroke="#DAE1E7"
      stroke-width="4"
      stroke-linecap="round"
    />
    <circle cx="34.5981" cy="39.0124" r="24.5792" transform="rotate(19.2186 34.5981 39.0124)" fill="#DAE1E7" />
    <circle
      cx="33.3163"
      cy="33.3163"
      r="26.1624"
      transform="rotate(19.2186 33.3163 33.3163)"
      stroke="#3D4852"
      stroke-width="1.2"
    />
    <line
      x1="50.8458"
      y1="54.7487"
      x2="68.7147"
      y2="73.0163"
      stroke="#3D4852"
      stroke-width="4"
      stroke-linecap="round"
    />
    <path
      d="M21.9091 40.2528C22.9989 42.6328 25.0674 47.2281 25.4889 47.1484C25.9104 47.0686 25.8573 42.4585 25.9359 39.8163C26.0087 37.2366 30.4026 36.1755 30.2984 35.3386C30.25 34.9556 26.9884 34.7137 25.452 32.6074C23.6679 30.1485 22.5175 25.4148 21.9867 25.4633C21.4698 25.5131 21.8018 29.918 20.5013 32.9436C19.2893 35.7742 16.4246 37.2167 16.4643 37.5428C16.5404 38.2298 20.837 37.9096 21.9091 40.2528Z"
      stroke="#3D4852"
      stroke-width="1.2"
      stroke-miterlimit="10"
    />
    <path
      d="M42.5084 42.691C42.7663 44.3375 43.2425 47.5106 43.5146 47.5343C43.7867 47.5581 44.5484 44.7231 45.0518 43.1171C45.5409 41.5485 48.417 41.6551 48.4973 41.1241C48.5336 40.881 46.5761 40.1708 45.9972 38.6151C45.3273 36.8005 45.4378 33.7008 45.104 33.639C44.7786 33.5805 44.2232 36.3377 42.9048 37.9682C41.6742 39.4944 39.6698 39.885 39.6379 40.0917C39.5662 40.526 42.2549 41.0699 42.5084 42.691Z"
      stroke="#3D4852"
      stroke-width="1.2"
      stroke-miterlimit="10"
    />
    <circle cx="33.4714" cy="21.642" r="3.57081" stroke="#3D4852" stroke-width="1.2" />
    <path
      d="M83.2299 13.4354C79.0486 17.0625 74.0576 19.7533 68.817 21.1973"
      stroke="#3D4852"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.9774 31.5829C79.426 32.443 86.9913 32.4358 94.4716 31.5556C96.3874 31.3295 98.3664 31.0241 99.9999 29.9775"
      stroke="#3D4852"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M69.0946 44.3096C77.2273 45.7089 84.9906 48.9331 91.6503 53.6681"
      stroke="#3D4852"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
